import { Theme as e, ThemeContext as t } from "../ThemeContext.js";
import { isDark as n, updateBodyClass as r, updateMetaThemeColor as i } from "../../../utils/theme.js";
import { ThemeColor as a } from "../../../types.js";
import o from "./ThemeProvider.module.js";
import { c as s } from "react/compiler-runtime";
import { useEffect as c, useRef as l } from "react";
import { jsx as u } from "react/jsx-runtime";
//#region src/components/Theme/ThemeProvider/ThemeProvider.tsx
var d = (d) => {
	let f = s(14), { children: p, systemTheme: m, onThemeChange: h, theme: g } = d, _ = m === void 0 ? e.light : m, v = g === void 0 ? e.auto : g, y = v === e.auto ? _ : v, b = n(y) ? a.dark : a.light, x = l(null), S, C;
	f[0] !== b || f[1] !== y || f[2] !== v ? (S = () => {
		r(y), i(v, b, x);
	}, C = [
		y,
		b,
		v
	], f[0] = b, f[1] = y, f[2] = v, f[3] = S, f[4] = C) : (S = f[3], C = f[4]), c(S, C);
	let w;
	f[5] !== h || f[6] !== _ || f[7] !== v ? (w = {
		theme: v,
		systemTheme: _,
		onThemeChange: h
	}, f[5] = h, f[6] = _, f[7] = v, f[8] = w) : w = f[8];
	let T = w, E;
	f[9] === p ? E = f[10] : (E = /* @__PURE__ */ u("div", {
		className: o.themeContainer,
		"data-test": "theme-container",
		children: p
	}), f[9] = p, f[10] = E);
	let D;
	return f[11] !== E || f[12] !== T ? (D = /* @__PURE__ */ u(t.Provider, {
		value: T,
		children: E
	}), f[11] = E, f[12] = T, f[13] = D) : D = f[13], D;
};
//#endregion
export { d as ThemeProvider };
